<form [formGroup]="changePasswordForm" (ngSubmit)="submitPasswordUpdate()">
  <div class="form-group mb-24">
    <label class="auth-label" for="currentPassword">Current password</label>
    <input
      [type]="currentFieldType ? 'text' : 'password'"
      id="currentPassword"
      class="auth-input"
      formControlName="oldPassword"
    />
    <span class="show-text">
      <i
        class="fa"
        [ngClass]="{
          'fa-eye-slash': !currentFieldType,
          'fa-eye': currentFieldType
        }"
        (click)="toggleCurrentPasswordFieldTextType()"
      ></i>
    </span>
  </div>
  <div class="form-group mb-24">
    <label class="auth-label" for="newPassword">New password</label>
    <input
      [type]="fieldTextType ? 'text' : 'password'"
      id="newPassword"
      class="auth-input"
      formControlName="newPassword"
    />
    <span class="show-text">
      <i
        class="fa"
        [ngClass]="{
          'fa-eye-slash': !fieldTextType,
          'fa-eye': fieldTextType
        }"
        (click)="toggleFieldTextType()"
      ></i>
    </span>
    <span
      class="text-danger"
      *ngIf="changePasswordForm?.controls?.['newPassword']?.touched"
    >
      <small
        *ngIf="
      changePasswordForm?.controls?.['newPassword']?.errors?.['pattern'] ||
      changePasswordForm?.controls?.['newPassword']?.invalid
    "
      >
        Password must be at least 8 characters with a combination of letters and
        numbers
      </small>
    </span>
  </div>

  <div class="form-group mb-24">
    <label class="auth-label" for="confirmPassword">Confirm new password</label>
    <input
      [type]="confirmFieldType ? 'text' : 'password'"
      id="confirmPassword"
      class="auth-input"
      formControlName="confirmPassword"
    />
    <span class="show-text">
      <i
        class="fa"
        [ngClass]="{
          'fa-eye-slash': !confirmFieldType,
          'fa-eye': confirmFieldType
        }"
        (click)="toggleConfirmationFields()"
      ></i>
    </span>
    <span
      class="text-danger"
      *ngIf="changePasswordForm?.controls?.['confirmPassword']?.touched"
    >
      <small
        *ngIf="
      changePasswordForm?.controls?.['confirmPassword']?.errors
        ?.['mustMatch']
    "
      >
        Passwords must match
      </small>
    </span>
  </div>

  <app-base-button
    label="Save new password"
    [disabled]="changePasswordForm.invalid"
    [colorClasses]="'custom__btn custom__btn-brand custom-btn-lg btn fw-600'"
  ></app-base-button>
</form>
